import { Routine } from 'redux-saga-routines';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { errorToast } from '../../../../common/helpers/toastrHelper';
import { checkPhoneNumber } from '../../../../services/contactService';
import { unreachablePhone } from '../../components/AddContactForm/utils';
import { addRefReqReferenceRoutine, updateRefReqReferenceRoutine } from '../../routines';

function* updateRef({ payload }: Routine<any>) {
  try {
    let isValidPhoneNumber = true;

    if (payload.data.phoneNumber) {
      const { isValid } = yield call(checkPhoneNumber, payload.data.phoneNumber);
      isValidPhoneNumber = isValid;
    }

    if (isValidPhoneNumber) {
      yield put(updateRefReqReferenceRoutine.success(payload));
    } else {
      yield call(errorToast, unreachablePhone.message, unreachablePhone.id);
    }
  } catch {
    yield put(updateRefReqReferenceRoutine.failure());
  }
}

function* watchUpdateRef() {
  yield takeEvery(updateRefReqReferenceRoutine.TRIGGER, updateRef);
}

function* checkAndAddRef({ payload }: Routine<any>) {
  try {
    let isValidPhoneNumber = true;
    if (payload.phoneNumber) {
      const { isValid } = yield call(checkPhoneNumber, payload.phoneNumber);
      isValidPhoneNumber = isValid;
    }

    if (isValidPhoneNumber) {
      yield put(addRefReqReferenceRoutine.success(payload));
    } else {
      yield call(errorToast, unreachablePhone.message, unreachablePhone.id);
    }
  } catch (error) {
    yield put(addRefReqReferenceRoutine.failure(error.message));
  }
}

function* watchAddRef() {
  yield takeEvery(addRefReqReferenceRoutine.TRIGGER, checkAndAddRef);
}

export default function* addRefsSaga() {
  yield all([watchUpdateRef(), watchAddRef()]);
}
